import React from 'react';

const stages = [
  {
    label: 'Impressions',
    keys: ['search', 'nearby', 'discover'],
    color: 'bg-blue-500',
  },
  {
    label: 'Views',
    keys: ['load'],
    color: 'bg-indigo-500',
  },
  {
    label: 'Engagement',
    keys: ['checkin', 'sip'],
    color: 'bg-emerald-500',
  },
  {
    label: 'Conversions',
    keys: ['call', 'website', 'directions', 'reservation'],
    color: 'bg-orange-500',
  },
];

export default function FunnelView({ metrics }) {
  if (!metrics) return null;

  const stageData = stages.map((stage) => ({
    ...stage,
    count: stage.keys.reduce((sum, key) => sum + (metrics[key] || 0), 0),
  }));

  const maxCount = Math.max(stageData[0]?.count || 1, 1);

  return (
    <div className="bg-white rounded-lg shadow p-5">
      <h4 className="text-base font-semibold text-gray-900">Conversion Funnel</h4>
      <p className="mt-1 text-sm text-gray-500">
        How visitors move through your listing
      </p>
      <div className="mt-6 space-y-3">
        {stageData.map((stage, i) => {
          const widthPct = Math.max((stage.count / maxCount) * 100, 8);
          const prevCount = i > 0 ? stageData[i - 1].count : null;
          const conversionPct =
            prevCount && prevCount > 0
              ? Math.round((stage.count / prevCount) * 100)
              : null;

          return (
            <div key={stage.label}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-medium text-gray-700">{stage.label}</span>
                <span className="text-sm text-gray-900 font-semibold">
                  {stage.count.toLocaleString()}
                  {conversionPct != null && (
                    <span className="ml-2 text-xs font-normal text-gray-500">
                      ({conversionPct}% of previous)
                    </span>
                  )}
                </span>
              </div>
              <div className="flex justify-center">
                <div
                  className={`${stage.color} h-8 rounded`}
                  style={{ width: `${widthPct}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
